// Every controller jane ships, registered in one line per host — the same
// shape as fire's register.js:
//
//   import { registerJane } from '@jane/register';
//   registerJane(application);
//
// One group, and no npm dependency beyond @hotwired/stimulus, because the
// marker draws on a plain <canvas> and nothing else. If that ever changes,
// split the export rather than making a host guess which package a build
// needs.
import MarkerController from './marker_controller';
import HelpController from './help_controller';
import WikiPageController from './wiki_page_controller';
import WikiAnchorsController from './wiki_anchors_controller';
import MiniAppController from './mini_app_controller';
import BrightController from './bright_controller';

export function registerJane(application) {
  application.register('bright', BrightController);
  application.register('marker', MarkerController);
  application.register('help', HelpController);
  application.register('wiki-page', WikiPageController);
  application.register('wiki-anchors', WikiAnchorsController);
  application.register('mini-app', MiniAppController);
}
